import type { IconContainerProps } from './typings'

import { IconContainer } from './elements/IconContainer'

export function Bulb(props: IconContainerProps) {
  return (
    <IconContainer {...props}>
      <svg
        width="28"
        height="36"
        viewBox="0 0 28 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.3648 35.5003H14.1202C12.4024 35.5003 11.0098 34.053 11.0098 32.2676H17.4753C17.4754 34.053 16.0827 35.5003 14.3648 35.5003Z"
          fill="#4383CC"
        />
        <path
          d="M24.5891 16.6174C24.5891 11.0309 20.0451 6.49222 14.4068 6.40649C8.72251 6.31997 3.98257 10.8552 3.90052 16.4666C3.84335 20.3791 6.0161 23.7943 9.24372 25.5575L9.35084 27.1373C9.36196 27.3012 9.43574 27.4547 9.55724 27.5669C9.67874 27.6791 9.83888 27.7415 10.0052 27.7415H18.4833C18.6496 27.7415 18.8098 27.6791 18.9313 27.5669C19.0528 27.4547 19.1265 27.3012 19.1377 27.1373L19.2448 25.5575C22.4309 23.8169 24.5891 20.4666 24.5891 16.6174Z"
          fill="#D4E3F3"
        />
        <path
          d="M18.6201 32.9145H9.87111C9.43044 32.9145 9.07324 32.5415 9.07324 32.0816V29.868C9.07323 29.7587 9.09386 29.6504 9.13395 29.5493C9.17404 29.4483 9.23281 29.3564 9.3069 29.2791C9.38099 29.2018 9.46895 29.1404 9.56576 29.0986C9.66257 29.0567 9.76633 29.0352 9.87111 29.0352H18.6201C18.7249 29.0351 18.8287 29.0567 18.9255 29.0985C19.0223 29.1404 19.1103 29.2017 19.1844 29.2791C19.2585 29.3564 19.3173 29.4482 19.3574 29.5493C19.3974 29.6503 19.4181 29.7587 19.4181 29.868V32.0816C19.418 32.5415 19.0608 32.9145 18.6201 32.9145Z"
          fill="#A1C1E6"
        />
        <path
          d="M13.1405 27.7414H11.3999V24.8091C10.6483 24.0259 8.83716 21.7496 8.50615 17.7263L8.42578 16.75H12.6081V18.55H10.3581C10.9203 22.0567 12.7373 23.6501 12.821 23.7219L13.1363 23.9917L13.1404 24.4186V27.7414H13.1405ZM17.0896 27.7414H15.3491V23.9886L15.6724 23.7184C15.7524 23.6498 17.5691 22.0568 18.1314 18.5501H15.8813V16.7501H20.0637L19.9833 17.7264C19.6521 21.7497 17.8411 24.026 17.0896 24.8091V27.7414H17.0896Z"
          fill="#0E4686"
        />
        <path d="M12.3057 30.3271H16.185V31.6203H12.3057V30.3271Z" fill="#4383CC" />
        <path
          d="M14.2446 5.10435C13.7162 5.10435 13.288 4.67974 13.288 4.15598V1.44837C13.288 0.924615 13.7162 0.5 14.2446 0.5C14.7729 0.5 15.2013 0.924615 15.2013 1.44837V4.15598C15.2013 4.67974 14.7729 5.10435 14.2446 5.10435ZM4.23151 9.27397C3.85793 9.64431 3.25221 9.64431 2.87863 9.27397L0.947179 7.35929C0.573597 6.98886 0.573597 6.38849 0.947179 6.01806C1.32076 5.64772 1.92648 5.64772 2.30006 6.01806L4.23151 7.93274C4.60518 8.30317 4.60518 8.90354 4.23151 9.27397ZM24.2576 9.27397C24.6312 9.64431 25.2369 9.64431 25.6105 9.27397L27.542 7.35929C27.9156 6.98886 27.9156 6.38849 27.542 6.01806C27.1684 5.64772 26.5627 5.64772 26.1891 6.01806L24.2576 7.93274C23.8841 8.30317 23.8841 8.90354 24.2576 9.27397Z"
          fill="#4383CC"
        />
      </svg>
    </IconContainer>
  )
}
